import { showToast } from "@certn/cascadia";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";

import { ActionListItemWithModal } from "./ActionListItemWithModal";
import { GeneralFeedbackModalContents } from "./GeneralFeedbackModalContents";
import {
  useGeneralFeedbackFormSubmit,
  useGeneralFeedbackSchema,
} from "./utils";

export function GeneralFeedback() {
  const { t } = useTranslation();

  const schema = useGeneralFeedbackSchema();
  const submitForm = useGeneralFeedbackFormSubmit();

  return (
    <ActionListItemWithModal
      testID="help-and-privacy-general-feedback-report-button"
      title={t("General feedback")}
      description={t(
        "We want to hear the good, the bad, and any ideas you may have"
      )}
      link={t("VERB Report", "Report")}
    >
      {({ close }) => (
        <Formik
          initialValues={{ topic: "", message: "" }}
          validationSchema={schema}
          onSubmit={async (values, helpers) => {
            try {
              await submitForm(values, helpers);
              close(); // once form submission successful, close modal
            } catch (e) {
              console.error(e);
              showToast(t("Something went wrong, try again"), {
                type: "error",
              });
            }
          }}
        >
          {({ handleSubmit }) => {
            return (
              <GeneralFeedbackModalContents
                handleSubmit={handleSubmit}
                close={close}
              />
            );
          }}
        </Formik>
      )}
    </ActionListItemWithModal>
  );
}
